import { motion } from "framer-motion";
import { galleryImages } from "../data/site";

// Column-based masonry via CSS columns for varied heights
export default function Gallery() {
    return (
        <section
            id="gallery"
            className="relative bg-[#0b0b0b] py-24 md:py-40 px-6 md:px-10"
            data-testid="gallery-section"
        >
            <div className="mx-auto max-w-[1440px]">
                <div className="flex items-center gap-6 mb-10">
                    <span className="w-16 h-px bg-[#C89B3C]" />
                    <span className="text-[10px] uppercase tracking-[0.4em] text-[#C89B3C]">
                        Chapter 12 — The Journal
                    </span>
                </div>

                <div className="grid grid-cols-12 gap-6 items-end mb-16">
                    <motion.h2
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-15%" }}
                        transition={{ duration: 0.9 }}
                        className="col-span-12 lg:col-span-8 font-display font-light text-white text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight"
                    >
                        Fragments of the <em className="text-[#E2C56D]">work.</em>
                    </motion.h2>
                    <motion.p
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-15%" }}
                        transition={{ duration: 0.9, delay: 0.15 }}
                        className="col-span-12 lg:col-span-4 text-[#bebebe] text-base leading-relaxed font-light"
                    >
                        Sites, structures, interiors, and drone frames from across our
                        portfolio.
                    </motion.p>
                </div>

                <div className="columns-2 md:columns-3 lg:columns-4 gap-4 md:gap-6 [column-fill:_balance]">
                    {galleryImages.map((src, i) => (
                        <motion.figure
                            key={src + i}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-5%" }}
                            transition={{ duration: 0.8, delay: (i % 4) * 0.08 }}
                            className="mb-4 md:mb-6 break-inside-avoid group relative overflow-hidden"
                            data-testid={`gallery-${i}`}
                            data-cursor="hover"
                        >
                            <img
                                src={src}
                                alt="portfolio frame"
                                loading="lazy"
                                className="w-full h-auto object-cover transition-transform duration-[1400ms] group-hover:scale-105"
                                style={{
                                    filter: i % 5 === 0 ? "grayscale(20%)" : "none",
                                }}
                            />
                            <div className="absolute inset-0 border border-transparent group-hover:border-[#C89B3C] transition-colors duration-500" />
                            <div className="absolute top-3 left-3 text-[9px] uppercase tracking-[0.35em] text-white/85 group-hover:text-[#E2C56D] transition-colors">
                                № {String(i + 1).padStart(2, "0")}
                            </div>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
